export default function briefRemoveUploadAction(context, payload, done) {
    context.dispatch('BRIEF_REMOVE_UPLOAD', payload);
    return done();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-remove-upload.jsx